import { NgModule } from '@angular/core';
import { AuthLightPopinComponent } from './auth-light-popin.component';
import { SigninFormLiteModule } from '../components/signin-form-lite/signin-form-lite.module';
import { SignupFormLiteModule } from '../components/signup-form-lite/signup-form-lite.module';
import { KzButtonModule } from '../../../kz-ui/ui/form/button/kz-button.module';
import { AuthSharedModule } from '../auth-shared.module';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    SigninFormLiteModule,
    SignupFormLiteModule,
    KzButtonModule,
    AuthSharedModule,
  ],
  declarations: [
    AuthLightPopinComponent
  ],
})
export class AuthLightModule { }
